document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("lookInsideModal");
  const iframe = document.getElementById("insideIframe");
  const pdpMainProd = document.querySelector('.pdp-main-prod');

  document.querySelector(".product__media-wrapper .b2l-button").addEventListener("click", function () {
    modal.style.display = "block";
    document.body.style.overflow = "hidden";
    if (pdpMainProd) pdpMainProd.style.position = 'static'; 
  });

  document.querySelectorAll(".b2l-modal-close").forEach(function (closeButton) {
    closeButton.addEventListener("click", function (e) {
      e.preventDefault();
      closeModal();
    });
  });

  function closeModal() {
    modal.style.display = "none";
    document.body.style.overflow = "";
    //iframe.src = "about:blank";
 
    if (pdpMainProd) pdpMainProd.style.position = ''; 
    if (pdpMainProd) pdpMainProd.style.zIndex = ''; 
  }

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" && modal.style.display === "block") {
      closeModal();
    }
  });
});
